<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48"><path fill="#000" d="M9 37.308V30.45c0-2.68.903-4.92 2.71-6.72 1.806-1.8 4.049-2.7 6.728-2.7h15.75l-8.4-8.4L27.42 11l11.165 11.165L27.42 33.331l-1.63-1.65 8.4-8.381h-15.75c-2.052 0-3.76.682-5.124 2.046-1.364 1.364-2.046 3.066-2.046 5.104v6.858H9Z"/></svg>
</template>
